_ = require 'underscore'
CustomFieldCardDetailBadgeView = require 'views/custom-field/custom-field-card-detail-badge-view'
Keyboard = require 'lib/keyboard'
Util = require 'lib/util'
isUrl = require 'lib/util/url/is-url'
t = require('views/internal/teacup-with-helpers')('custom_fields')

module.exports = class CustomFieldTextCardDetailBadgeView extends CustomFieldCardDetailBadgeView
  template: t.renderable ({ icon, name, text, editable, color } = {}) ->
    t.h3 '.card-detail-item-header', { title: name }, ->
      t.icon icon
      t.text name

    if editable
      if isUrl(text) || Util.checkEmail(text)
        t.div '.u-relative.custom-field-external-link', ->
          t.input '.custom-field-detail-badge.is-clickable.js-custom-field-detail-badge' + color,
            autocomplete: 'off'
            'data-lpignore': true
            maxlength: 16000
            size: Math.max text.length + 1, 10
            title: text
            type: 'text'
            value: text
          if isUrl(text)
            t.a { href: text, target: '_blank', rel: 'noreferrer nofollow', title: text }, ->
              t.icon 'external-link'
          else if Util.checkEmail(text)
            t.a { href: "mailto:#{text}", title: text }, ->
              t.icon 'email'
      else
        t.input '.custom-field-detail-badge.is-clickable.js-custom-field-detail-badge' + color,
          autocomplete: 'off'
          'data-lpignore': true
          maxlength: 16000
          placeholder: t.l('add field value', { fieldName: name.toLowerCase() })
          size: Math.max text.length + 1, 10
          title: text
          type: 'text'
          value: text

    if isUrl(text)
      t.a '.custom-field-detail-badge.is-clickable' + color,
        class: t.classify({ 'printable-badge': editable })
        href: text
        target: '_blank'
        rel: 'noreferrer nofollow'
        title: text
      , ->
        t.text text
    else if Util.checkEmail(text)
      t.a '.custom-field-detail-badge.is-clickable' + color,
        class: t.classify({ 'printable-badge': editable })
        href: "mailto:#{text}"
        title: text
      , ->
        t.text text
    else
      t.span '.custom-field-detail-badge' + color,
        class: t.classify({ 'printable-badge': editable })
        title: text
      , ->
        t.text text

  events:
    'keydown .js-custom-field-detail-badge': 'handleEnter'
    'focusin .js-custom-field-detail-badge': 'startEditCustomFieldBadgeText'
    'focusout .js-custom-field-detail-badge.js-is-editing': 'editCustomFieldBadgeText'

  startEditCustomFieldBadgeText: (e) ->
    @track()
    e.target.classList.add('js-is-editing')
    e.target.parentElement.classList.add('editing')

  handleEnter: (e) ->
    if Keyboard.isSubmitEvent(e)
      @$(e.target).blur()

  editCustomFieldBadgeText: (e) ->
    Util.stop(e)
    e.target.classList.remove('js-is-editing')
    e.target.parentElement.classList.remove('editing')
    newVal = e.target.value.trim()

    if !@customFieldItem?
      if newVal
        @model.customFieldItemList.create({
          idCustomField: @customField.id
          idModel: @model.id
          modelType: 'card'
          value:
            text: newVal
        })
      return

    oldVal = @customFieldItem.getParsedValue()
    # check to see if the value has changed
    if newVal == oldVal
      return

    if newVal == ''
      @customFieldItem.clearValue()
    else
      @customFieldItem.setValue({ text: newVal })



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/custom-field-text-card-detail-badge-view.coffee